export default function PrivacyPolicyPage() {
  return (
    <div className="mx-auto max-w-2xl px-6 pt-40">
      <div className="prose max-w-none">
        <h1 className="mb-8 font-recursive text-3xl font-bold">
          Low Code Plugins Privacy Policy
        </h1>

        <p className="text-lg font-semibold">PRIVACY POLICY</p>
        <p className="mb-6 text-sm">Last Updated: December 6, 2024</p>

        <p className="mb-6">
          This Privacy Policy describes how Wise Growth Marketing LLC, doing
          business as "Low Code Plugins" ("we", "us", or "our"), collects, uses,
          and protects your personal information when you use our services.
        </p>

        <ol className="list-decimal space-y-6 pl-6">
          <li>
            <p className="mb-2 font-semibold">Information We Collect</p>
            <ol className="list-decimal space-y-2 pl-6">
              <li>
                Personal Information:
                <ul className="list-disc space-y-2 pl-6 pt-2">
                  <li>Name</li>
                  <li>Email address</li>
                </ul>
              </li>
              <li>
                Derivative Data:
                <ul className="list-disc space-y-2 pl-6 pt-2">
                  <li>Log and usage data</li>
                  <li>Device data</li>
                  <li>Location data</li>
                </ul>
              </li>
            </ol>
          </li>

          <li>
            <p className="mb-2 font-semibold">How We Use Your Information</p>
            <ol className="list-decimal space-y-2 pl-6">
              <li>Delivering and facilitating our services</li>
              <li>Fulfilling and managing user orders</li>
              <li>Responding to user inquiries</li>
              <li>Sending administrative information</li>
              <li>Determining the effectiveness of promotional campaigns</li>
              <li>Identifying usage trends</li>
              <li>Protecting our service</li>
              <li>Requesting user feedback</li>
              <li>Sending marketing and promotional communications</li>
            </ol>
          </li>

          <li>
            <p className="mb-2 font-semibold">Information Sharing</p>
            <ol className="list-decimal space-y-2 pl-6">
              <li>
                We do not share your personal information with third parties,
                except as necessary for payment processing through Stripe.
              </li>
              <li>
                Note: Stripe may collect additional user information. Please
                review Stripe's privacy policy at{" "}
                <a
                  href="https://stripe.com/privacy"
                  target="_blank"
                  rel="noreferrer"
                  className="underline"
                >
                  https://stripe.com/privacy
                </a>{" "}
                for more details about their data collection and usage
                practices.
              </li>
            </ol>
          </li>

          <li>
            <p className="mb-2 font-semibold">Data Security</p>
            <ol className="list-decimal space-y-2 pl-6">
              <li>
                We implement appropriate technical and organizational measures
                to protect your personal information against unauthorized
                access, alteration, disclosure, or destruction.
              </li>
            </ol>
          </li>

          <li>
            <p className="mb-2 font-semibold">Your Rights</p>
            <ol className="list-decimal space-y-2 pl-6">
              <li>You have the right to:</li>
              <li>Request access to your personal information</li>
              <li>Request correction of your personal information</li>
              <li>Request deletion of your personal information</li>
              <li>Opt-out of marketing communications</li>
            </ol>
          </li>

          <li>
            <p className="mb-2 font-semibold">Changes to This Policy</p>
            <ol className="list-decimal space-y-2 pl-6">
              <li>
                We may update this Privacy Policy from time to time. We will
                notify you of any changes by posting the new Privacy Policy on
                this page.
              </li>
            </ol>
          </li>

          <li>
            <p className="mb-2 font-semibold">Contact Information</p>
            <ol className="list-decimal space-y-2 pl-6">
              <li>
                For any questions or concerns regarding this Privacy Policy,
                please contact us at support@lowcodeplugins.com
              </li>
            </ol>
          </li>

          <li>
            <p className="mb-2 font-semibold">Acceptance of Terms</p>
            <ol className="list-decimal space-y-2 pl-6">
              <li>
                By using our service, you signify your acceptance of this
                Privacy Policy. If you do not agree with the terms, please do
                not use our service.
              </li>
            </ol>
          </li>
        </ol>
      </div>
    </div>
  );
}
